import { useEffect, useState } from "react";
import { MdDelete, MdEdit, MdOutlineRemoveRedEye } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { parseISO, format } from "date-fns";

import SideBar from "../../../components/SideBar/SideBar";
import TableColumn from "../../../components/TableColumn/TableColumn";
import TopNav from "../../../components/TopNav/TopNav";
import api from "../../../services/api";

const VenueQueries = () => {
  const navigate = useNavigate();

  const [queries, setQueries] = useState();

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(
    Number(localStorage.getItem("ListCurrentPageVenueQueries")) || 1
  );
  const records = 10;

  const sortableColumns = ["Venue", "Time", "Status"];

  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState("null");
  // Bumped after each delete to trigger a refetch of the current page so
  // freshly-emptied slots refill from the backend.
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const formatDate = (isoDate) => {
    const date = parseISO(isoDate);
    return format(date, "MMM dd yyyy, HH:mm");
  };

  useEffect(() => {
    const getSupports = async (page) => {
      try {
        const response = await api.get(`/supports`, {
          params: {
            records: 10,
            page: page,
            type: "venue",
            sort_column: sortBy,
            sort: sortDirection,
          },
        });

        const itensTableColumns = response.data.data.map((queries) => ({
          _id: queries._id,
          Text: queries.description,
          Time: formatDate(queries.created_at),
          Venue: queries.user_name,

          Status:
            (queries.status === "opened" ? "open" : queries.status)
              .charAt(0)
              .toUpperCase() +
            (queries.status === "opened" ? "open" : queries.status).slice(1),
        }));

        setQueries(itensTableColumns);
        setTotalPages(response.data.total);
      } catch (error) {
        console.log(`users get request didn't work. error: ${error}`);
      }
    };

    getSupports(currentPage);
  }, [navigate, currentPage, sortBy, sortDirection, refreshTrigger]);

  const deleteQuery = async (id) => {
    if (!window.confirm('Delete this query? This cannot be undone.')) return;
    try {
      await api.delete(`/supports/${id}`);
      // Trigger a refetch of the current page so the freshly-emptied slot
      // gets refilled by the next item from the backend.
      setRefreshTrigger((t) => t + 1);
    } catch (err) {
      alert('Failed to delete: ' + (err?.response?.data?.message || err.message));
    }
  };

  const actions = [
    {
      label: <MdEdit size={30} color="#4F30EA" />,

      onClick: (rowData) => {
        console.log(rowData);
        navigate(`/queries/edit/${rowData._id}`);
      },
    },
    {
      label: <MdDelete size={30} color="#d12c2c" />,
      onClick: (rowData) => deleteQuery(rowData._id),
    },
  ];

  const columns = ["Venue", "Time", "Text", "Status"];

  const fetchAllData = async () => {
    try {
      const response = await api.get(`/supports`, {
        params: {
          records: 9999999999,
          type: "venue",
        },
      });

      return response.data.data.map((queries) => ({
        _id: queries._id,
        Text: queries.description,
        Time: formatDate(queries.created_at),
        Venue: queries.user_name,

        Status:
          (queries.status === "opened" ? "open" : queries.status)
            .charAt(0)
            .toUpperCase() +
          (queries.status === "opened" ? "open" : queries.status).slice(1),
      }));
    } catch (error) {
      console.log(`Error fetching all data: ${error}`);
      return [];
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    localStorage.setItem("ListCurrentPageVenueQueries", page);
  };

  useEffect(() => {
    const storedPage = localStorage.getItem("ListCurrentPageVenueQueries");

    setCurrentPage(Number(storedPage) || 1);
  }, []);

  const getStatusColor = (status) => {
    console.log(status);
    const capitalizedStatus =
      status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    switch (capitalizedStatus) {
      case "Solved":
        return "rgba(231, 76, 60, 0.1)";
      case "Approved":
        return "rgba(46, 204, 113, 0.1)";
      case "Claiming":
        return "rgba(441, 196, 15, 0.1)";
      case "Pending":
        return "rgba(231, 76, 60, 0.1)";
      case "Accepted":
        return "rgba(46, 204, 113, 0.1)";
      default:
        return "inherit";
    }
  };

  const sortColumnsMapping = {
    Venue: "user_name",
    Time: "created_at",
    Status: "status",
  };

  const handleSort = (columnName) => {
    const backendColumnName = sortColumnsMapping[columnName];
    if (sortBy === backendColumnName) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(backendColumnName);
      setSortDirection("asc");
    }
  };

  return (
    <section className="queries">
      <TableColumn
        columns={columns}
        data={queries}
        sortableColumns={sortableColumns}
        hasExport={true}
        hasSearch={false}
        actions={actions}
        getStatusColor={getStatusColor}
        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        records={records}
        fetchAllData={fetchAllData}
        onSort={handleSort}
      />
    </section>
  );
};

export default VenueQueries;
